import React from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as usersActions from '../store/users/actions';
import * as reducers from '../store/reducers';

import Loading from 'Components/Loading';
import ContentFrame from 'Components/ContentFrame';
import SectionHeader from 'Components/SectionHeader';
import TextBlock from 'Components/TextBlock';
import PageMessage from 'Components/PageMessage';
import ContactLink from 'Components/ContactLink';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class EmailUnsubscribe extends React.Component {
  componentDidMount() {
    const { location, token, changeEmailSubscriptions } = this.props;
    const { type } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    const changeset = {
      marketing_email_subscription: true,
      newsletter_subscription: true,
    };

    // TODO: We’re not handling newsletter subscriptions for now, so it’s
    // a little hard-code-y.
    if (type === 'tips_tricks') {
      changeset.marketing_email_subscription = false;
    }
    changeEmailSubscriptions(token, changeset);
  }

  render() {
    const { message } = this.props;
    if (!message || message.type === 'info') return <Loading />;

    return (
      <main className="Page__content">
        {message.type === 'success' ? (
          <ContentFrame pageType="transactional" size="small">
            <PageMessage
              title={<ConnectedFormattedMessage id="unsubscribe_page.title" />}
              text={
                <span>
                  <ConnectedFormattedMessage
                    id="unsubscribe_page.body"
                    values={{
                      email_link: (
                        <ContactLink label="support.schools@tinybop.com" />
                      ),
                    }}
                  />
                </span>
              }
              type="success"
            />
          </ContentFrame>
        ) : (
          <ContentFrame pageType="transactional" size="small">
            <SectionHeader
              title={<ConnectedFormattedMessage id="errors.generic_title" />}
              subtitle={
                message.errorCode ? (
                  <ConnectedFormattedMessage
                    id="errors.display_error_code"
                    values={{ error_code: message.errorCode }}
                  />
                ) : null
              }
            />
            <TextBlock
              type="large"
              description={
                <p className="TextBlock__paragraph">
                  <ConnectedFormattedMessage id={message.msgId} />
                </p>
              }
            />
          </ContentFrame>
        )}
      </main>
    );
  }
}

const mapStateToProps = (state, { location }) => {
  const { token } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  // TODO router - verify this works
  return {
    activeUser: reducers.getActiveUser(state),
    token: decodeURIComponent(token),
    message: reducers.getMessage(state, 'email_subscription'),
  };
};

export default withRouter(
  connect(mapStateToProps, usersActions)(EmailUnsubscribe)
);
